const getKey = (row, keyExpr) => (row && row[keyExpr] !== undefined && row[keyExpr] !== null ? String(row[keyExpr]) : null);

export const getSelectedRowsPage = (loadedRows, selectedRows, options = {}) => {
    const keyExpr = options.keyExpr || 'id';
    const latestByKey = new Map(
        (loadedRows instanceof Array ? loadedRows : [])
            .map((row) => [getKey(row, keyExpr), row])
            .filter(([key]) => key !== null)
    );
    const seen = new Set();
    const rows = (selectedRows instanceof Array ? selectedRows : [])
        .filter((row) => {
            const key = getKey(row, keyExpr);
            if (key === null || seen.has(key)) return false;
            seen.add(key);
            return true;
        })
        .map((row) => ({ ...row, ...(latestByKey.get(getKey(row, keyExpr)) || {}) }));

    const pageSize = Math.max(1, Number(options.pageSize) || rows.length || 1);
    const pageIndex = Math.max(0, Number(options.pageIndex) || 0);
    return {
        data: rows.slice(pageIndex * pageSize, (pageIndex + 1) * pageSize),
        totalCount: rows.length
    };
};

export default getSelectedRowsPage;
